import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaBuilding,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const RealEstateVideoServicesInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Real Estate Video Services in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Showcase Your Properties</Subheading>}
        heading={
          <Heading>
            Real Estate <span tw="text-primary-500">Video Services</span> in
            DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we provide premier real estate video services in
            **DIFC**, creating cinematic, engaging, and high-quality videos that
            showcase properties and drive sales. From luxury villas to
            commercial spaces, our videos captivate buyers and investors.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1560184897-ae75f418493e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern Dubai property
          "https://images.unsplash.com/photo-1582610116397-edb318620f90?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Luxury apartment in Dubai
          "https://images.unsplash.com/photo-1600607687644-c7f34b5063c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Elegant interior design
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Showcase Your Property"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Premier Real Estate Video Services in DIFC"
        description="We create videos that sell properties faster."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Cinematic Visuals",
            description: "Stunning videos that highlight property features.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success for DIFC real estate clients.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Tours",
            description: "Virtual tours that captivate buyers.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Delivery",
            description: "Quick turnaround for market-ready videos.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for websites, social media, and listings.",
          },
          {
            icon: <FaBuilding color="#ff5464" size={40} />,
            title: "Property Focused",
            description: "Tailored for luxury and commercial spaces.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Real Estate Video Production Process"
        description={
          <Description>
            We produce impactful real estate videos with a strategic process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Understand your property and marketing goals.
              </li>
              <li>
                Planning: Develop concepts for virtual tours and highlights.
              </li>
              <li>Filming: Capture properties with professional equipment.</li>
              <li>
                Editing: Enhance with music, voiceovers, and seamless
                transitions.
              </li>
              <li>Delivery: Provide ready-to-share real estate videos.</li>
              <li>Support: Offer insights for maximizing buyer engagement.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Property interior view
          "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern building exterior
          "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Stylish apartment living room
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Real Estate Video Wins in DIFC"
        description="Our videos have driven property sales in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Faster Sales",
            description: "Videos that accelerate property transactions.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Views",
            description: "Boosted engagement on listings and platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from real estate video projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell Your Property?</Subheading>}
        heading="Real Estate Video Services in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for real estate video services in DIFC.
            Create cinematic, engaging videos that showcase your properties and
            attract buyers—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Luxury villa
          "https://images.unsplash.com/photo-1600210492493-0946911123ea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Modern kitchen design
          "https://images.unsplash.com/photo-1464938050520-ef2270bb8ce8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80", // Dubai skyline with property
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
